/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkstationMini
 */
export interface WorkstationMini {
    /**
     * 
     * @type {string}
     * @memberof WorkstationMini
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationMini
     */
    readonly displayName: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationMini
     */
    hostname: string;
}

export function WorkstationMiniFromJSON(json: any): WorkstationMini {
    return WorkstationMiniFromJSONTyped(json, false);
}

export function WorkstationMiniFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkstationMini {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'displayName': json['display_name'],
        'hostname': json['hostname'],
    };
}

export function WorkstationMiniToJSON(value?: WorkstationMini | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'hostname': value.hostname,
    };
}


